<template>
  <div style="border: 3px solid blue; display: flex">
    <div style="border: 3px solid red; width: 28%">
      <LeftTweet
        @changeTab="handletemplateUpdate"
        :refresh-flag="refreshFlag"
        :close-num="closeNum"
      ></LeftTweet>
    </div>

    <!-- 子应用容器 注入另外一个项目 官网https://wujie-micro.github.io/doc/guide/-->
    <div style="border: 5px solid blue; width: 75%">
      这里是新建推文
      <iframe
        ref="editorFrame"
        :src="editorUrl"
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="auto"
        @load="onIframeLoad"
      ></iframe>
      <!-- <div>
        <WujieVue
          v-if="showEditor"
          width="100%"
          name="vue3-editor"
          :url="editorUrl"
          :sync="true"
          :alive="true"
          :props="editorProps"
          @load="handleEditorLoaded"
          ref="wujieRef"
           v-bind="{...$attrs, style: undefined}"
        />
      </div> -->
    </div>
  </div>
</template>
<script>
// 如果使用wujie-vue
import WujieVue from "wujie-vue2";
const { bus } = WujieVue;
export default {
  name: "ArticleTemplateIndex",
  props: {
    datas: Object,
  },
  data() {
    return {
      isIframeReady: false, // 标记 iframe 是否加载完成
      showEditor: false,
      editorUrl: "http://192.168.3.194:7101",
      initialContent:
        "<h2>欢迎使用富文本编辑器</h2><p>在这里开始编写您的文档内容...</p>",
      editorProps: {},
      isEditorReady: false,
      contentStats: null,
      refreshFlag: 0,
      closeNum: 0,
      form: {
        title: "",
        category: "",
        content: "",
      },
    };
  },
  mounted() {
    console.log("主应用挂载成功------------------------");
    window.addEventListener("message", this.handleEditorMessage);
    // 确保wujieBus已正确挂载
    // this.initEditor();
    // this.setupEventBus();
    // document.body.style.height = "95vh";
    // document.body.style.overflow = "hidden";
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleEditorMessage);
  },

  methods: {
    sendContent(content) {
      console.log("调用了吗", content);
    },
    // iframe 加载完成
    onIframeLoad() {
      console.log("✅ iframeiframeiframeiframeiframe 准备就绪！");
      this.isIframeReady = true;
    },

    // 接收 Vue3 富文本内容
    handleEditorMessage(event) {
      console.log("📩 收到任意 message:", event); // 先打印所有消息
      // 安全校验：只允许你的编辑器域名通信（防劫持）
      const allowDomain = "http://192.168.3.194:7101";
      if (event.origin !== allowDomain) return;

      const data = event.data;

      // 编辑器内容变化
      if (data.type === "editor-content-change") {
        console.log(
          "✅ 收到富文本内容111111111111111111111111111111111111111：",
          data.content,
        );
        this.form.content = data.content; // 直接存入表单
      }
      console.log("收到富文本内容-----------------", this.form);
    },
    // 设置 EventBus 监听
    setupEventBus() {
      // 监听子应用发送的内容变化事件
      bus.$on("editor-content-change", this.handleContentChangeFromBus);

      // 监听子应用发送的编辑器就绪事件
      bus.$on("editor-ready", this.handleEditorReadyFromBus);

      // 监听设置内容的响应
      bus.$on("editor-content-set", this.handleContentSetFromBus);
    },
    // 编辑器加载完成
    handleEditorLoaded() {
      console.log("🎉 编辑器加载完成");
      this.isEditorReady = true;
      this.$message.success("富文本编辑器加载完成");
    },
    initEditor() {
      this.showEditor = false;
      this.isEditorReady = false;
      this.contentStats = null;

      // 通过 props 传递数据和方法给子应用
      this.editorProps = {
        // 初始内容
        initialContent: this.initialContent,
        // 内容变化回调函数
        onContentChange: this.handleContentChange,
        // 编辑器配置
        config: {
          editable: true,
          placeholder: "请输入内容...",
        },
      };

      setTimeout(() => {
        this.showEditor = true;
        console.log("🔄 编辑器初始化，URL:", this.editorUrl);
      }, 100);
    },
    // 从 Props 接收内容变化
    handleContentChange(content) {
      console.log("📝 通过Props接收内容变化:", {
        htmlLength: content.html,
        textLength: content.text,
      });

      this.updateContent(content);
    },
    // 统一更新内容
    updateContent(content) {
      this.form.content = content.html || "";
      this.contentStats = {
        htmlLength: content.html || 0,
        textLength: content.text || 0,
        updateTime: new Date().toLocaleTimeString(),
      };
      console.log("统一更新内容", this.form, this.contentStats);
    },

    async handletemplateUpdate(rows) {
      console.log("父组件接收到模板数据:", rows);
      // 1. 获取模板内容（你原来的逻辑）
      let content =
        "<h2>默认内容默认内容默认内内容默认内容内容默认内容内容默认内容容</h2>";
      // 2. 等待 iframe 准备好再发送（关键！）
      const sendContent = () => {
        console.log("调用了吗");
        this.$refs.editorFrame.contentWindow.postMessage(
          {
            type: "setTemplateContent", // 👈 固定类型
            html: content, // 👈 模板HTML
          },
          "*",
        );
      };
      // 如果已就绪，直接发
      if (this.isIframeReady) {
        sendContent();
      } else {
        // 没就绪，等 300ms 再发
        setTimeout(() => {
          sendContent();
        }, 300);
      }
      // this.updateData = rows;
      try {
        //   // 等待获取文件内容
        //   let content;
        //   if (rows.url) {
        //     content = await this.getOSSFileContent(rows.url);
        //   } else {
        //     content =
        //       "<h2>欢迎使用富文本编辑器</h2><p>在这里开始编写您的文档内容...</p>";
        //   }
        //   if (content) {
        //     // 更新初始内容
        //     this.initialContent = content;
        //     // 如果编辑器已经加载，需要重新设置内容
        //     if (this.isEditorReady) {
        //       // 通过 EventBus 发送命令给子应用更新内容
        //       bus.$emit("editor-command", {
        //         type: "set-content",
        //         content: content,
        //       });
        //       // 同时更新本地表单内容
        //       this.form.content = content;
        //     } else {
        //       // 如果编辑器还没加载，重新初始化编辑器
        //       this.initEditor();
        //     }
        //     // this.$message.success('模板内容已加载')
        //   }
      } catch (error) {
        console.error("加载模板内容失败:", error);
        this.$message.error("加载模板内容失败");
      }
    },
  },
};
</script>
<style scoped lang="scss">
h1 {
  color: #333;
}
</style>
